import React, { useEffect, useRef, useState } from 'react';
import { Link, useFetcher, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default function SwiperStyle1(props) {
    const { listsImag=[] } = props;
    const [swiper, setswiper] = useState({});

    const dispatch = useDispatch();
    const navigate = useNavigate();

    return (
        <div style={{ position: 'relative' }}>
            {listsImag?.length > 1 &&
            <>
            <button onClick={() => swiper.slidePrev()} className='slidenavigateButton left'>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path fillRule="evenodd" clipRule="evenodd" d="M15.7071 4.29289C16.0976 4.68342 16.0976 5.31658 15.7071 5.70711L9.41421 12L15.7071 18.2929C16.0976 18.6834 16.0976 19.3166 15.7071 19.7071C15.3166 20.0976 14.6834 20.0976 14.2929 19.7071L7.29289 12.7071C6.90237 12.3166 6.90237 11.6834 7.29289 11.2929L14.2929 4.29289C14.6834 3.90237 15.3166 3.90237 15.7071 4.29289Z" fill="white"/>
                </svg>                
            </button>
            <button onClick={() => swiper.slideNext()} className='slidenavigateButton right'>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path fillRule="evenodd" clipRule="evenodd" d="M8.29289 4.29289C8.68342 3.90237 9.31658 3.90237 9.70711 4.29289L16.7071 11.2929C17.0976 11.6834 17.0976 12.3166 16.7071 12.7071L9.70711 19.7071C9.31658 20.0976 8.68342 20.0976 8.29289 19.7071C7.90237 19.3166 7.90237 18.6834 8.29289 18.2929L14.5858 12L8.29289 5.70711C7.90237 5.31658 7.90237 4.68342 8.29289 4.29289Z" fill="white"/>
                </svg>            
            </button>
            </>
            }

            <Swiper
                onInit={(ev) => {
                    setswiper(ev)
                }}
                loop={true}
                modules={[Navigation, Pagination, Scrollbar, A11y]}
                spaceBetween={0}
                slidesPerView={1}
                onSlideChange={() => console.log('slide change')}
                onSwiper={(swiper) => console.log(swiper)}
            >
                {listsImag?.length > 0 && listsImag?.map((x, i) => {
                    return (
                        <SwiperSlide key={i}>
                            <div className='productDetailSlider' style={{ backgroundImage: 'url('+ x +')' }} />
                        </SwiperSlide>
                    );
                })}
            </Swiper>
        </div>
    )    
}